import { z } from 'zod/v3';

export const productCatalogMainRouteSearchSchema = z.object({
  addModalOpen: z.boolean().optional(),
  addSuccessorModalOpen: z.boolean().optional(),
  connectModalOpen: z.boolean().optional(),
  copyProductModalOpen: z.boolean().optional(),
  countryCode: z.string().optional(),
  from: z.string().optional(),
  lang: z.string().optional(),
  productCode: z.string().optional(),
  productId: z.string().optional(),
  productIds: z.array(z.string()).or(z.literal('FILTERED')).optional(),
  relatedProductId: z.string().optional(),
  removeSuccessionModal: z.enum(['predecessor', 'successor']).optional(),
  replaceModalOpen: z.boolean().optional(),
});

export type ProductCatalogMainRouteSearchSchemaType = z.infer<
  typeof productCatalogMainRouteSearchSchema
>;

export const productSearchRouteSearchSchema = z.object({
  conditions: z.array(z.string()).optional(),
  feedConnectionStatuses: z
    .array(z.enum(['CONNECTED', 'PARTIALLY_CONNECTED', 'DISCONNECTED', 'NO_FEED_DATA']))
    .optional(),
  includeProductsWithoutQualityScore: z.boolean().optional(),
  q: z.coerce.string().optional(),
  qualityScoreMax: z.coerce.string().optional(),
  qualityScoreMin: z.coerce.string().optional(),
  sortBy: z.enum(['UPDATED_AT', 'CREATED_AT', 'IDQ_SCORE_ASC', 'IDQ_SCORE_DESC']).optional(),
  uploadDocumentsModalOpen: z.boolean().optional(),
  uploadImagesModalOpen: z.boolean().optional(),
  uploadModalOpen: z.boolean().optional(),
  uploadMode: z.enum(['create', 'update']).optional(),
});

export type ProductSearchRouteSearchSchemaType = z.infer<typeof productSearchRouteSearchSchema>;

export const productDetailsRouteSearchSchema = z.object({
  outerCaseId: z.string().optional(),
  outerCaseInitialProductId: z.string().optional(),
  productFamilyModalOpen: z.boolean().optional(),
  readOnly: z.boolean().optional(),
});

export type ProductDetailsRouteSearchSchemaType = z.infer<typeof productDetailsRouteSearchSchema>;

export const outerCasesIndexRouteSearchSchema = z.object({
  outerCaseId: z.string().optional(),
  outerCaseInitialProductId: z.string().optional(),
  q: z.coerce.string().optional(),
});

export type OuterCasesIndexRouteSearchSchemaType = z.infer<typeof outerCasesIndexRouteSearchSchema>;

export const productFamiliesMainRouteSearchSchema = z.object({ q: z.coerce.string().optional() });

export const productCreationReviewRouteSearchSchema = z.object({
  hide: z.array(z.enum(['EXISTING', 'SKIPPED'])).optional(),
  page: z.coerce.number().int().positive().optional(),
});

export const reviewRouteSearchSchema = z.object({
  hide: z.array(z.enum(['EXISTING', 'SKIPPED'])).optional(),
  page: z.coerce.number().int().positive().optional(),
  uploadModalOpen: z.boolean().optional(),
});

export type ReviewRouteSearchSchemaType = z.infer<typeof reviewRouteSearchSchema>;
